"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUp = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
exports.ArrowUp = react_1.default.memo(function (_a) {
    var color = _a.color, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("g", __assign({ clipPath: "url(#arrow-up0)" }, { children: (0, jsx_runtime_1.jsx)("path", { stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "".concat(!isSelected || isDisabled ? '1.5' : '2.5'), d: "M16 4v24M8 12l8-8 8 8" }) })), (0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsx)("clipPath", __assign({ id: "arrow-up0" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: "#fff", d: "M0 0H32V32H0z", transform: "matrix(1 0 0 -1 0 32)" }) })) })] }));
});
